<template>
  <div class="footer">
    <!-- Footer -->
    <footer class="page-footer font-medium #e7717d pt-4">
      <!-- Footer Text -->
      <div class="container-fluid text-center text-md-left">
        <!-- Grid row -->
        <div class="row">
          <!-- Grid column -->
          <div class="col-md-6 mt-md-0 mt-3">
            <div class="left-col">
              <img src="../assets/logo-SheImage.png" alt="Logo" class="logo2" />
              <br />
              <p>
                SHE
                <i>image</i> Print and Stationery
                <br />
                <b>Quality</b> to
                <i>perfection.</i>
              </p>
              <div class="left-foot-text" id="contact">
                <p>
                  <strong>Contact Us</strong>
                  <br />
                  <a href="tel:0545 051 244">0545 051 244</a>
                  <br />
                  <a href="tel:0248 157 274">0248 157 274</a>
                  <br />
                  <a href="mailto:sheimage@gmail.com">sheimage@gmail.com</a>
                </p>

                <div class="social-media">
                  <a href="tel:0248 157 274" target="_parent">
                    <i class="fab fa-whatsapp-square"></i>
                  </a>
                  <a
                    href="https://instagram.com/sheimage?igshid=gdznzxdumghw"
                    target="_parent"
                  >
                    <i class="fab fa-instagram"></i>
                  </a>
                  <a href="https://www.linkedin.com/in/anna-valera-carsamer-4708a210a" target="_parent">
                    <i class="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- Grid column -->
          <hr class="clearfix w-100 d-md-none pb-3" />
          <!-- Grid column -->
          <div class="col-md-6 mb-md-0 mb-3">
            <div class="right-col" id="rightCol">
              <h1>Our Newsletter</h1>
              <p>
                {{ msg }}
              </p>
              <form @submit.prevent="btnSubmit" class="newsletter-form px-3">
                <input
                  type="email"
                  class="txtb"
                  placeholder="Enter Your Email"
                  v-model="emailFooter"
                  optional
                />
                <input type="submit" class="btn" value="Submit" />
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer Text -->

      <!-- Copyright -->
      <div class="footer-copyright text-center py-3">
        <div class="container center">
          © {{currentDate.getFullYear()}} SHE
          <i>Image</i>. All rights reserved.
        </div>
      </div>
      <!-- Copyright -->
    </footer>
    <!-- Footer -->
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      msg: "Enter Your Email to get our discount offers and product updates.",
      emailFooter: "",
      currentDate: new Date,
    };
  },
  methods: {
    btnSubmit() {
      this.msg = "Thank you for subscribing to our newsletters.";
      this.emailFooter = ""
    }
  }
};
</script>

<style scoped>
.logo2 {
  width: 10%;
  height: 15%;
}

.right-col p {
  font-weight: 700;
}
.left-col {
  text-align: center;
}

#contact p a {
  text-decoration: none;
  color: black;
}

#contact p a:hover {
  color: white;
  font-weight: 700;
}

.social-media {
  margin: 10px 0;
}

.social-media a {
  color: #001a21;
  margin-right: 25px;
  font-size: 22px;
  text-decoration: none;
  transition: 0.1s linear;
}

.social-media a:hover {
  color: white;
}

.right-col {
  text-align: center;
}

.right-col h1 {
  font-size: 26px;
}

.newsletter-form {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.txtb {
  flex: 1;
  padding: 15px 30px;
  font-size: 16px;
  color: #293043;
  background: #c5c4c4;
  border: none;
  font-weight: 700;
  outline: none;
  border-radius: 30px;
  min-width: 260px;
}

.btn {
  font-size: 16px;
  color: #f1f1f1;
  background: black;
  border: none;
  font-weight: 700;
  outline: none;
  border-radius: 30px;
  margin-left: 20px;
  cursor: pointer;
  transition: opacity 0.2s linear;
}

.btn:hover {
  opacity: 0.6;
}
</style>
